import Link from 'next/link'
import { FiEdit2 } from 'react-icons/fi'
export default function PartnerItem({partner, currentUser, active = false}) {
    function isAdmin(partner) {
        if (currentUser._id === partner.userId._id) {
            return true
        }
        const partnerUser = partner.users.find(u => u.userId._id === currentUser._id)
        if (partnerUser.level !== 'ADMIN') {
            return false
        }
        return true
    }

    return (
        <div className={`flex cursor-pointer justify-between box ${active && 'box-active'} box-hover`}>
            <div>
                <div className="mb-3">
                    <p className="text-lg">
                        {partner.name}
                    </p>
                </div>
                <div className="flex items-center">
                    <span className="text-sm text-gray-800">{partner.users.length || 'Nenhum'} usu&aacute;rio{partner.users.length > 0 ? 's' : ''} adicionado{partner.users.length > 0 ? 's' : ''}</span>
                </div>
            </div>
            <div className="flex flex-col justify-between items-end">
                { /*isAdmin(partner) && 
                <Link href={`/teams/${partner._id}`}>
                    <a>
                        <button className="btn btn-gray">
                            <FiEdit2 />
                        </button>
                    </a>
                </Link>
                */}
            </div>
        </div>
    )
}
